import React from "react";
import BarGraph from "./BarGraph";

/**
 * MonthlyTourPlanning Component
 * Displays monthly tour planning statistics with a bar chart
 * Refactored with Tailwind CSS
 * 
 * @component
 */
const MonthlyTourPlanning = () => {
  return (
    <div className="w-[94%] mx-4 my-2 mb-6 h-40 bg-white rounded-xl shadow-[0.056rem_0.056rem_0.241rem_rgba(20,20,20,0.07)]">
      {/* Header */}
      <div className="w-full h-[2.125rem] bg-[#3901FF] rounded-t-xl flex items-center justify-between px-5">
        <div className="text-white font-semibold text-[0.688rem] leading-8">
          Monthly Tour Planning
        </div>
        <div className="flex items-center gap-2 text-white font-medium text-[0.563rem] max-[320px]:text-[0.463rem]">
          <div className="flex items-center gap-2">
            <span className="w-[0.375rem] h-[0.375rem] bg-[#FFA600]"></span>
            <span>Planned</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-[0.375rem] h-[0.375rem] bg-[#28B963]"></span>
            <span>Completed</span>
          </div>
        </div>
      </div>

      {/* 15 Days Indicator */}
      <div className="flex items-center px-2 pt-2">
        <div className="text-[#3901FF] font-semibold text-[0.527rem] px-2">
          15 Days
        </div>
        <div 
          className="flex-1 h-[0.044rem] mx-2" 
          style={{
            background: 'repeating-linear-gradient(90deg, #3901FF 0 0.625rem, transparent 0 0.75rem)'
          }}
        ></div>
      </div>

      {/* Bar Graph */}
      <div className="px-2">
        <BarGraph />
      </div>
    </div>
  );
};

export default MonthlyTourPlanning;
